export default "__VITE_ASSET__CFDBJaL6__"